export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11142.0269cf15.jpg";